import { useCallback } from 'react'
import { useSlate } from 'slate-react'

import { Button } from 'core-components/library/button'
import { Menu } from 'core-components/library/menu'
import { TOOLBAR_BUTTONS } from 'core-components/library/richTextEditor/interface/IToolbar'
import { IFormatCrudItem } from 'core-components/library/richTextEditor/toolbar/components/dropDown/BaseDropDown'

import { TOOLBAR_TITLES } from '../../constants'
import { getIconFromFormat } from '../../helpers/iconHelper'
import { IBaseDropDown, IPropsForRender } from '../../interface/IToolbarProps'

export function MenuForToolbar<T>({
  onToggle,
  format,
  className,
  source,
  disabled,
  defaultValue,
  formats,
}: IPropsForRender<T> & IBaseDropDown<T>) {
  const editor = useSlate()

  const onChoose = useCallback(
    (value: T) => {
      onToggle(editor, value, format === value)
    },
    [editor, format, onToggle]
  )

  return (
    <Menu<IFormatCrudItem<T>, T>
      className={className || ''}
      source={source}
      caption={'icon'}
      onChoose={onChoose}
      itemTpl={(item) => {
        return <i data-testid={`align-${item.icon}`} className={item.icon} />
      }}
      content={() => {
        return (
          <Button
            iconButton={getIconFromFormat(format || defaultValue, formats)}
            title={TOOLBAR_TITLES[TOOLBAR_BUTTONS.Align]}
            disabled={disabled}
            variant={'text'}
            color={'grey'}
          />
        )
      }}
    />
  )
}
